<find-bar>
  <input class="find-input" type="text" oninput="{ handleChange }" onkeydown="{ onKeyDown }">
  <div class="find-count">
    <div class="find-count-text">{ state.currentMark }</div>
    <span>/</span>
    <div class="find-count-text">{ state.markElements.length }</div>
  </div>
  <div class="find-icon" onclick="{ markPrevious }"><i class="fa fa-angle-up"></i></div>
  <div class="find-icon" onclick="{ markNext }"><i class="fa fa-angle-down"></i></div>
  <div class="find-icon" onclick="{ props.onClose }"><i class="fa fa-times"></i></div>
  <script>
    import { findTextNode, cleanMarkElement } from '@/common/utils/dom';
    export default {
      state: {
        currentMark: 0,
        markElements: [],
      },
      onMounted() {
        this.$('.find-input').focus();
      },
      onUpdated() {
        cleanMarkElement();
        requestAnimationFrame(() => this.updateMark());
      },
      updateMark() {
        cleanMarkElement();
        const value = this.$('.find-input')?.value ?? '';
        if (value == '') {
          this.state.currentMark = 0;
          this.state.markElements = [];
          return;
        }
        this.state.markElements = findTextNode(document.body, value);
        if (this.state.markElements.length == 0) {
          this.state.currentMark = 0;
        } else if (this.state.markElements.length < this.state.currentMark) {
          this.state.currentMark = 1;
        }
        if (this.state.currentMark > 0) {
          const mark = this.state.markElements[this.state.currentMark - 1];
          if (mark) {
            mark.style.backgroundColor = '#ff8c00';
          }
        }
      },
      handleChange(e) {
        cleanMarkElement();
        if (e.target.value == '') {
          this.state.currentMark = 0;
          this.state.markElements = [];
          this.update();
          return;
        }
        this.state.markElements = findTextNode(document.body, e.target.value);
        const len = this.state.markElements.length;
        if (0 < len) {
          this.state.currentMark = 1;
          const mark = this.state.markElements[this.state.currentMark - 1];
          mark.style.backgroundColor = '#ff8c00';
          mark.scrollIntoView({ block: 'center', inline: 'center' });
        } else {
          this.state.currentMark = 0;
        }
        this.update();
      },
      checkMarkElements() {
        if ((this.state.markElements.length == 0 || document.querySelectorAll('mark').length == 0) && this.$('.find-input').value != '') {
          cleanMarkElement();
          this.updateMark();
        }
      },
      markNext() {
        this.checkMarkElements();
        const len = this.state.markElements.length;
        if (len == 0) {
          return;
        }
        if (0 <= this.state.currentMark - 1) {
          const mark = this.state.markElements[this.state.currentMark - 1];
          mark.style.backgroundColor = '#ffff00';
        }
        if (len <= this.state.currentMark) {
          this.state.currentMark = 1;
        } else if (this.state.currentMark < len) {
          this.state.currentMark += 1;
        }
        cleanMarkElement();
        this.updateMark();
        const mark = this.state.markElements[this.state.currentMark - 1];
        if (mark) {
          mark.style.backgroundColor = '#ff8c00';
          mark.scrollIntoView({ block: 'center', inline: 'center' });
        }
        this.update();
      },
      markPrevious() {
        this.checkMarkElements();
        const len = this.state.markElements.length;
        if (len == 0) {
          return;
        }
        if (0 <= this.state.currentMark - 1) {
          const mark = this.state.markElements[this.state.currentMark - 1];
          mark.style.backgroundColor = '#ffff00';
        }
        if (this.state.currentMark <= 1) {
          this.state.currentMark = len;
        } else if (1 < this.state.currentMark) {
          this.state.currentMark -= 1;
        }
        cleanMarkElement();
        this.updateMark();
        const mark = this.state.markElements[this.state.currentMark - 1];
        if (mark) {
          mark.style.backgroundColor = '#ff8c00';
          mark.scrollIntoView({ block: 'center', inline: 'center' });
        }
        this.update();
      },
      onKeyDown(e) {
        e = e || window.event;
        const code = e.which || e.keyCode;
        if (code == 13) {
          this.markNext();
        }
      },
    };
  </script>
  <style>
    :host {
      z-index: 99999;
      position: fixed;
      top: 2px;
      right: 4px;
      padding: 4px;
      padding-left: 12px;
      border: 1px solid #dddddd;
      border-radius: 4px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .find-input {
      border: none;
      outline: none;
    }

    .find-count {
      display: inline-block;
      font-size: 14px;
    }

    .find-count-text {
      display: inline-block;
      text-align: center;
      width: 21px;
    }

    .find-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
    }

    .find-icon:hover {
      background-color: #ececec;
    }
  </style>
</find-bar>